export enum FiTagsListPositionTypes {
    Left = 1,
    Top = 2,
}

export enum FiTagsSelectionTypes {
    AllTags = 1,
    SelectedTags = 2,
}

export enum FiTagsSortType {
    Alphabetical = 1,
    Manual = 2,
}
